/**
 * @param {unknown} err
 * @param {string} fallback
 * @returns {string}
 */
export function packageRedeemErrorMessage(err, fallback) {
  const response = /** @type {{ data?: { errors?: Record<string, string[]>, message?: string } }} */ (
    err?.response
  )
  const errors = response?.data?.errors

  if (errors) {
    const priority = ['sale', 'service_ids', 'service_id', 'customer_package_id', 'customer_id']
    for (const field of priority) {
      const message = errors[field]?.find(Boolean)
      if (message) return message
    }

    const first = Object.values(errors).flat().find(Boolean)
    if (first) return first
  }

  return response?.data?.message ?? fallback
}

/**
 * @param {unknown} err
 * @param {string} fallback
 * @returns {string}
 */
export function packagePayErrorMessage(err, fallback) {
  const response = /** @type {{ data?: { errors?: Record<string, string[]>, message?: string } }} */ (
    err?.response
  )
  const errors = response?.data?.errors

  if (errors?.sale?.[0]) {
    return errors.sale[0]
  }

  if (errors?.payments?.[0]) {
    return errors.payments[0]
  }

  return response?.data?.message ?? fallback
}
